<template>
  <div class="start flex-grow-1 flex-fill">
    <Translate />
    <section class="row">
      <div class="col-4 px-3 py-5 d-none d-md-flex"></div>
      <div class="col-24 col-md-16 px-3 align-items-center d-flex">
        <div class="row align-itens-center">
          <div
            class="col-md-11 min-h text-right justify-content-start align-items-end d-flex flex-column pr-3"
          >
            <img src="../../assets/svg/logo.svg" class="align-self-end mb-2" />
            <h1
              class="title"
              v-text="$ml.get('yourSecurityPlatformAndBugReward')"
            >
              A sua plataforma de segurança e recompensa por bugs
            </h1>
            <p v-text="$ml.get('youWillReceiveReportsFromCommunity')">
              Você recebe feedbacks dos especialistas de segurança da nossa
              comunidade, sem custo adicional, enquanto minimiza as chances de
              expor suas vulnerabilidades na mídia ou redes sociais
            </p>
          </div>
          <div class="col-2 min-h d-none d-md-flex justify-content-center py-3">
            <span class="line align-self-center"></span>
          </div>
          <div
            class="col-24 col-md-11 min-h text-left justify-content-start align-items-end d-flex flex-column mt-5 pl-md-3"
          >
            <div class="card w-100">
              <div class="card-body">
                <h5 v-text="$ml.get('emailConfirmation')">
                  Confirmação de e-mail
                </h5>
                <p v-text="$ml.get('toConfirmYourRegistrationOn')">
                  Para confirmar seu cadastro em nossa plataforma é necessário
                  clicar no botão abaixo.
                </p>
                <form v-on:submit.prevent="">
                  <transition name="fade">
                    <div v-show="msgSuccess" class="alert alert-success">
                      <font v-text="$ml.get('emailSuccessfullyValidated')"
                        >Email validado com sucesso!</font
                      > 
                      <font v-text="$ml.get('youWillBeRedirectedIn')"
                        >Você será redirecionado em</font
                      >
                      {{ seconds }}
                      <font v-text="$ml.get('seconds')">segundos</font>.
                    </div>
                  </transition>
                  <transition name="fade">
                    <div
                      v-show="msgdanger"
                      class="alert alert-danger"
                      v-text="msgdanger"
                    ></div>
                  </transition>
                  <div class="row">
                    <button
                      @click="validEmail()"
                      :disabled="loadingBtn"
                      class="btn btn-lg btn-block"
                    >
                      <Spinner v-show="loadingBtn" />
                      <span
                        v-show="!loadingBtn"
                        v-text="$ml.get('yesIWantToRegister')"
                        >Sim, quero me cadastrar</span
                      >
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import axios from "axios";
import Translate from "../../components/translate.vue";

export default {
  page: {
    title: "Validação de Email",
    meta: [{ name: "description" }],
  },
  components: {
    Translate,
  },
  data() {
    return {
      token: "",
      email: "",
      seconds: 5,
      loadingBtn: false,
      msgSuccess: false,
      msgdanger: false,
    };
  },
  mounted() {
    this.token = this.$route.query.key;
    this.email = this.$route.query.email;
  },
  methods: {
    async validEmail() {
      this.loadingBtn = true;
      this.msgSuccess = false;
      this.msgdanger = false;

      var self = this;
      delete axios.defaults.headers.common["Authorization"];
      axios
        .put(
          this.$store.getters["getApiUrl"] +
            `hacker/email-validation/${this.token}?email=${this.email}`
        )
        .then(function() {
          self.msgSuccess = true;
          var refreshInterval = setInterval(() => {
            if (self.seconds > 0) {
              self.seconds = self.seconds - 1;
            } else {
              self.loadingBtn = false;
              self.$router.push({
                name: "login",
                params: {
                  email: self.email,
                },
              });
              clearInterval(refreshInterval);
            }
          }, 1000);
        })
        .catch(function(err) {
          if (err.response.data.message == "Token inválido") {
            setTimeout(() => {
              self.loadingBtn = false;
              self.msgdanger = self.$ml.get(
                "aNewValidationEmailHasBeenSenToYou"
              );
            }, 1500);
            return;
          }
          setTimeout(() => {
            self.loadingBtn = false;
            self.msgdanger = self.$ml.get("emailAlreadyValidatedNonExistent");
          }, 1500);
        });
    },
  },
};
</script>
